export default [
    {
        name: 'Projetos',
        url: '/sgtec/fornecedor/projetos',
        icon: 'fa fa-book',
        regras: 'SGTEC-FORN-PRJ-00',
        badge: {
            variant: 'primary',
            text: 'SGTEC'
        }
    },
    {
        name: 'Etapas',
        url: '/sgtec/fornecedor/etapas',
        icon: 'fa fa-tasks',
        regras: 'SGTEC-FORN-ETP-00',
        badge: {
            variant: 'primary',
            text: 'SGTEC'
        }
    },
    {
        name: 'Pagamentos',
        url: '/sgtec/fornecedor/pagamentos',
        icon: 'fa fa-dollar',
        regras: 'SGTEC-FORN-PAG-00',
        badge: {
            variant: 'primary',
            text: 'SGTEC'
        }
    }
]
